export default __webpack_public_path__ + "static/media/wTop_3_p3.05a36c87.jpeg";